import { render } from "./Favorites.vue?vue&type=template&id=01e5e619&scoped=true"
import script from "./Favorites.vue?vue&type=script&lang=js"
export * from "./Favorites.vue?vue&type=script&lang=js"

import "./Favorites.vue?vue&type=style&index=0&id=01e5e619&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e5e619"]])

export default __exports__